import { StyleSheet, Platform } from 'react-native';

export default StyleSheet.create({
  titleContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  iconTextContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    ...Platform.select({
      web: {
        flexShrink: 1
      },
      default: {}
    })
  },
  icon: (theme) => ({
    tintColor: theme.colors.textColor,
    marginRight: 11,
    height: 32,
    width: 32,
  }),
  title: {
    fontSize: 18.7,
    lineHeight: 25,
    paddingTop: Platform.OS === 'ios' ? 5 : null,
    fontWeight: 700
  },
  subTitle: {
    marginLeft: 45,
    fontSize: 14.6,
    marginTop: 10,
    lineHeight: 18.7,
  },
  subTitleContainer: {
    paddingRight: 16,
  },
});
